import React , {useState} from 'react';

import img1 from '../../assets/images/layouts/about-01.png'
import img2 from '../../assets/images/layouts/about-02.png'
import img3 from '../../assets/images/layouts/about-03.png'
import img4 from '../../assets/images/layouts/about-04.png'
import img5 from '../../assets/images/layouts/about-05.png'
import Button from '../button/Button';

function About(props) {

    const [dataImg] = useState([
        {
            id: 1,
            img : img1,
            class: 'img1'
        },
        {
            id: 2,
            img : img2,
            class: 'img2'
        },
        {
            id: 3,
            img : img3,
            class: 'img3'
        },
        {
            id: 4,
            img : img4,
            class: 'img4'
        },
        {
            id: 5,
            img : img5,
            class: 'img5'
        },
    ])

    const [dataBlock] = useState(
        {
            subheading: 'Who We Are',
            heading: 'NXTLVL Nights — Where Orlando Gets Wild',
            desc1: 'We don’t just throw parties — we set the city on fire. NXTLVL is the top-tier nightlife experience in Orlando. From reggaeton to hip-hop to global beats, we bring the heat and keep it moving all weekend.',
            desc2: 'Whether you’re here to flex, vibe, or disappear into the music, we’ve got your night. Come correct or don’t come at all. This isn’t for the faint of heart — it’s for those living NXTLVL.'
        }
    )

    return (
        <section className="about">
            <div className="shape"></div>
            <div className="container">
                <div className="row rev">
                    <div className="col-xl-6 col-md-12">
                        <div className="about__right">
                            <div className="images">
                                {
                                    dataImg.map(idx => (
                                        <img key={idx.id} className={idx.class} src={idx.img} alt="nxtlvl" />
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-md-12">
                        <div className="block-text" >
                            <h6 className="sub-heading"><span>{dataBlock.subheading}</span></h6>
                            <h3 className="heading">{dataBlock.heading}</h3>
                            <p className="mb-17">{dataBlock.desc1}</p>
                            <p className="mb-26">{dataBlock.desc2}</p>
                            <Button link='/about' title='More About Us' />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;